import React, {useState, useEffect} from "react";
import axios from "axios";
import './css/Main.scss';
import {Viewer} from './Viewer';
import { EldmlTransformerHelper } from "./eldmlTransform/EldmlTransformerHelper";

const noopHelper: EldmlTransformerHelper = {
  force: false,
  mobile: false,

  getImageSrc: async () => {
    return "";
  },

  getVideoSrc: async () => {
    return null;
  },

  onImageClick: () => {
    /* noop */
  },

  executeAction: () => {
    /* noop */
  },

  fetchUsers: async () => {
    return [];
  },

  getAvatarSrc: () => {
    return "";
  },

  onAvatarClick: () => {
    /* noop */
  },


  processPdf: () => {
    /* noop */
  },

  processSpreadsheet: () => {
    /* noop */
  },

  onFileClick: () => {
    /* noop */
  },

  translate: async (text) => {
    return text;
  }
};


export default function App() {
	const [data, setData] = useState<{css: string, eldml: string} | null>(null);

	let api = axios.create({
		baseURL: ``,
	});

	useEffect(() => {
		const params = Object.fromEntries(new URLSearchParams(window.location.search));
		api.post('v1/data/fetch',params).then(res => {
			if (res && res.data) {				
				if (res.data.css) {
					var styleSheet = document.createElement("style");
					styleSheet.innerText = res.data.css.replace(/[<]br[^>]*[>]/gi, "");
					document.head.appendChild(styleSheet);
				}
				setData(res.data);
			}
		});
	}, []);

	return (<React.Fragment>
	{data && 
		<div>
			<Viewer content={data.eldml} eldmlTransformer={noopHelper} />
		</div>}
	</React.Fragment>
					);
}